export const CenteredView = ({children}) => {
    return <div className="flex h-screen w-screen items-center content-center justify-center">{children}</div>
}